import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Twitter(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M12.063 31.06c12.076 0 18.68-10.005 18.68-18.68 0-.285 0-.568-.019-.85A13.309 13.309 0 0034 8.133c-1.198.531-2.47.88-3.77 1.033a6.59 6.59 0 002.886-3.631c-1.29.765-2.7 1.303-4.17 1.593a6.571 6.571 0 00-11.187 5.988 18.637 18.637 0 01-13.532-6.86 6.572 6.572 0 002.033 8.765 6.516 6.516 0 01-2.98-.822v.083a6.567 6.567 0 005.267 6.436 6.554 6.554 0 01-2.964.113 6.575 6.575 0 006.133 4.56A13.176 13.176 0 012 28.111a18.573 18.573 0 0010.063 2.944" />
    </IconSvg>
  );
}
